import {
  ChatThreadModel,
  DeleteThreadRequest,
  GetThreadByIdRequest,
  InitOverrideFunction,
  ThreadApi,
} from "../../../@api";

export class ThreadApiService
  implements Omit<ThreadApi, `${string}Raw` | "withMiddleware" | "withPreMiddleware" | "withPostMiddleware">
{
  constructor(private readonly api: ThreadApi) {}

  public async deleteThread(requestParameters: DeleteThreadRequest): Promise<void> {
    return this.api.deleteThread(requestParameters);
  }
  public async getAllUserThreads(initOverrides?: RequestInit | InitOverrideFunction): Promise<Array<ChatThreadModel>> {
    return this.api.getAllUserThreads(initOverrides);
  }

  public async getThreadById(requestParameters: GetThreadByIdRequest): Promise<ChatThreadModel> {
    return this.api.getThreadById(requestParameters);
  }
}
